// test1878
(1878 && 0);
